import React from 'react';
import dynamic from 'next/dynamic';
import classNames from 'classnames';
import StickyBox from 'react-sticky-box';

import PostAuthor from '../../PostAuthor/PostAuthor';
import PostCategory from '../../PostCategory/PostCategory';
import Divider from '../../Divider/Divider';
import ReadingTime from '../../ReadingTime/ReadingTime';
import PostDate from '../../PostDate/PostDate';
import PostReviewer from '../../PostReveiwer/PostReviewer';
import SocialShare from '../../SocialShare/SocialShare';
import PostTag from '../../PostTag/PostTag';
import RelatedPost from '../../Widget/RelatedPost/RelatedPost';
import FooterBanner from '../../Banners/FooterBanner/FooterBanner';
import EditButton from '../../EditButton/EditButton';

import { contentHandler } from '../../../lib/contentHandler';

import useAuthenticated from '../../../utils/hooks/useAuthenticated';
import useResponsive from '../../../utils/hooks/useResponsive';
import styles from '../../../styles/pages/SinglePost.module.scss';

const Post = ({ post, relatedPosts, ctaTexts }) => {
  const { isDesktop } = useResponsive();
  const authenticated = useAuthenticated();

  const widgetView = () => {
    const Widget = dynamic(() => import('../../Widget/Widget'));

    return (
      <div className={styles['widgets__after-post']}>
        <Widget
          post={post}
          classname="after-post"
          type={isDesktop ? 'DESKTOP_AFTER_POST' : 'MOBILE_AFTER_POST'}
          relatedPosts={relatedPosts}
        />
      </div>
    );
  };

  return (
    <>
      <EditButton postId={post.databaseId} />
      <div className={styles['single-post__wrapper']}>
        <div className={`${styles.row} row`}>
          <div className="col-lg-8 col-md-12">
            <div className={classNames(styles['single__post--grid'], 'mb-3')}>
              <div
                className={styles.post}
                itemScope={post.hasFaq}
                itemType={post.hasFaq ? 'https://schema.org/FAQPage' : ''}
              >
                <div className={styles.post__header}>
                  <div className={styles.post__meta}>
                    {post.author && <PostAuthor author={post.author.node} />}
                    <span className="ml-1 mr-1">/</span>
                    <PostCategory categories={post.categories} />
                    <Divider />
                    <ReadingTime time={post.readingTime} />
                    <Divider />
                    <PostDate createdDate={post.date} />
                  </div>
                  <h1 className={styles.post__title}>{post.title}</h1>
                  <div className={styles.post__info}>
                    {post.setting.postReviewer && (
                      <PostReviewer reviewers={post.setting.postReviewer} />
                    )}
                    <SocialShare slug={post.slug} title={post.title} />
                  </div>
                </div>
                <div className={styles['post__featured-image']}>
                  {post.featuredImage && (
                    <img
                      src={post.featuredImage?.node.sourceUrl}
                      alt={post.featuredImage?.node.altText || post.title}
                      width={738}
                      height={416}
                      sizes={post.featuredImage?.node.sizes}
                    />
                  )}
                </div>
                <div className={`content ${styles.post__content}`}>
                  {contentHandler(post.content, post.slug, post.title, post, false, ctaTexts)}
                </div>
                <div className={styles.post__footer}>
                  <SocialShare slug={post.slug} title={post.title} />
                  <PostTag tags={post.tags.nodes} />
                </div>
              </div>
            </div>
            {widgetView()}
          </div>
          <StickyBox offsetTop={100} className={`${styles.widgets__sidebar} col-lg-4 col-md-12`}>
            <div className={styles.widget__item}>
              <RelatedPost relatedPosts={relatedPosts} />
            </div>
          </StickyBox>
        </div>
      </div>
      {!isDesktop && !authenticated && <FooterBanner slug={post.slug} banner={post.footerBanner} />}
    </>
  );
};

export default Post;
